import { Map } from "immutable"
import _ from "lodash"

export default function(pricing) {
  const _pricingArr = _.values(pricing)
  let nthPricing = Map()

  _pricingArr.forEach((price, i) => {
    const keyIndex = i + 1

    nthPricing = nthPricing.set(
      keyIndex.toString(), // must be string value
      _pricingArr[i - 1] ? _pricingArr[i] - _pricingArr[i - 1] : _pricingArr[i],
    )
  })

  return nthPricing
}
